import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';

function BlendxCarousel(props) {
  const { children, className } = props;
  return (
    <Carousel className={classNames('blendx-carousel-wrapper', className)}>
      {children.map((child, index) => (
        <Carousel.Item key={index}>
          {child}
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

BlendxCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string
};

BlendxCarousel.defaultProps = {
  className: '',

};

export default BlendxCarousel;
